import { MessageTemplateListResponse} from "@/types/service-response";


export class MessageTemplateList {
    private constructor(
        readonly id: string,
        readonly name: string,
        readonly createdAt: string,
        readonly subject: string,
        readonly text: string
    ) {}

    static createFromResponseList (responseData: MessageTemplateListResponse[]): MessageTemplateList[]{
        return  responseData.map((item: MessageTemplateListResponse)=>{
                return new MessageTemplateList(
                    item.id,
                    item.name,
                    item.createdAt,
                    item.subject,
                    item.text,
                )
            }
        )
    }


    static createFromResponse(responseData: MessageTemplateListResponse): MessageTemplateList {
        return new MessageTemplateList(
            responseData.id,
            responseData.name,
            responseData.createdAt,
            responseData.subject,
            responseData.text,
        )
    }
}
